<template>
  <div class="gallery">
    <!-- 添加编辑栏 -->
    <div class="gallery__header">
      <h2 class="gallery__header-title">
        {{ $t('tianmu.qualityLight') }}
      </h2>
      <div class="gallery__header-actions">
        <div v-if="!isEdit" class="gallery__header-control">
          <span @click="isEdit = true">{{ $t('base.modify') }}</span>
        </div>
        <div v-else class="gallery__header-control">
          <span class="red" @click="handlerDelete">{{ $t('base.delete') }}</span>
          <span @click="isEdit = false">{{ $t('base.cancel') }}</span>
        </div>
      </div>
    </div>

    <section v-for="category in galleryData" :key="category.title" class="gallery__section">
      <h2 class="gallery__title">
        {{ category.title }}
      </h2>

      <div class="gallery__list">
        <div v-for="(item, index) in category.items" :key="index" class="gallery__item-wrapper">
          <Card
            :item="item"
            :is-edit="isEdit"
            @createScene="createScene"
            @reSyncDeviceConfig="reSyncDeviceConfig"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { GetTianMuDevicePlanLibrary } from '@/axios/IDevice.js'
import { Create, Delete, ReSyncDeviceConfig } from '@/axios/IScene.js'
import Card from './Card.vue'
import { alerterror, alertsuccess, warning, success } from '@/assets/js/common.js'

export default {
  components: {
    Card,
  },

  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      galleryData: [],
      isEdit: false, // 编辑模式
    }
  },
  computed: {
    socketmodel() {
      return this.$store.state.socketmodel //需要监听的数据
    },
  },
  watch: {
    socketmodel(rs) {
      this.functionScoketsync_info_event(rs)
    },
  },

  mounted() {
    this.getGalleryData()
  },

  methods: {
    functionScoketsync_info_event(rs) {
      // 1. 校验响应数据结构
      if (!rs || rs.StatusCode !== this.$store.state.rightStatusCode) return
      if (!rs.Result || !Array.isArray(rs.Result) || rs.Result.length === 0) return
      
      const resultData = rs.Result[0]
      if (resultData.Type !== 19 || !resultData.SceneId) return
      
      // 2. 检查是否有匹配的场景（避免重复刷新）
      const hasMatchingScene = this.galleryData.some(category =>
        category.items.some(item => item.SceneId === resultData.SceneId)
      )
      
      if (hasMatchingScene) {
        this.getGalleryData()
      }
    },

    async getGalleryData() {
      try {
        // 1. 校验设备信息
        if (!this.device || !this.device.VDeviceId || !this.device.ClassSku) {
          // console.warn('设备信息不完整，无法获取画廊数据')
          return
        }

        const res = await GetTianMuDevicePlanLibrary({
          PageIndex: 1,
          PageSize: 99,
          VDeviceId: this.device.VDeviceId,
          ClassSkus: [this.device.ClassSku],
          manualPageSize: true,
          ProductType: 'PrimeLight',
          Types: ['品质光'], // 只能中文
          ResourceTypes: ['Video', 'Image'],
        })


        // 2. 校验响应数据
        if (!res || Number(res.StatusCode) !== this.$store.state.rightStatusCode) {
          alerterror(this, res?.StatusCode)
          return
        }

        const list = res.Result?.DataList || []
        
        // 3. 空数据处理
        if (list.length === 0) {
          this.galleryData = []
          return
        }

        const listJson = {}
        const galleryData = []

        list.forEach(item => {
          // 4. 数据字段校验
          if (!item.SubType) return
          
          if (!listJson[item.SubType]) {
            listJson[item.SubType] = [item]
          } else {
            listJson[item.SubType].push(item)
          }
        })

        Object.values(listJson).forEach(list => {
          if (list.length === 0) return
          
          galleryData.push({
            title: list[0].SubType,
            items: list.map(item => ({
              name: item.Name || '--',
              img: item.Icon || '',
              FileList: item.FileList || [],
              Id: item.Id,
              SceneId: item.SceneId,
              SceneStatus: item.SceneStatus || 0, // 0 表示未配置
              isChecked: false, // 添加选中状态
            })),
          })
        })

        this.galleryData = galleryData
        console.log('galleryData', galleryData)
      } catch (error) {
        // console.error('获取画廊数据失败:', error)
        alerterror(this, this.$t('tianmu.uploadFailed'))
        this.galleryData = []
      }
    },

    async reSyncDeviceConfig(item){
      const para = { 
        sceneNo: item.SceneId, 
        vDeviceId: this.device.VDeviceId, 
        channelId: this.device.ChildId 
      };
      const res = await ReSyncDeviceConfig(para)
      debugger
      if(res.StatusCode === this.$store.state.rightStatusCode){
        this.getGalleryData()
      }
    },

    async createScene(item) {
      try {
        // 1. 校验必要参数
        if (!item || !item.FileList || !Array.isArray(item.FileList)) {
          return
        }

        if (!this.device || !this.device.VDeviceId) {
          return
        }

        // 2. 查找 BinUrl
        const BinList = item.FileList
        const bin = BinList.find(fileItem => (fileItem.ColorModel === 1 && fileItem.ClassSku === this.device.ClassSku))
        
        if (!bin || !bin.BinUrl) {
          return
        }

        // 3. 如果已配置，直接应用场景
        if (item.SceneStatus === 1 && item.SceneId) {
          return
        }

        // 4. 构建创建场景参数
        const params = {
          GpNo: this.device.Gpno, // 房间号
          SecneName: item.name || '--', // 场景名
          isFavorite: false, // 固定
          IconUrl: item.img || '',
          WellSkyTemplateId: item.Id || '', // 主题光专用场景模板id
          ShowEntry: 6,
          TransportType: 'VideoScene',
          DeviceList: [
            {
              AreaName: this.device.AreaName || '',
              Mac: this.device.Mac,
              DeviceName: this.device.DeviceName,
              VDeviceId: this.device.VDeviceId,
              ChannelId: this.device.ChildId,
              ActionList: [
                {
                  MsgType: '0x131D0000', //固定值
                  Values: [
                    { KeyId: 0, Value: 0 },
                    { KeyId: 1, Value: 0 },
                    { KeyId: 2, Value: parseInt('0xFFFFFFFF') },
                    { KeyId: 3, Value: 255 },
                    { KeyId: 4, Value: parseInt('0xFFFFFFFF') },
                    { KeyId: 5, Value: bin.BinUrl }, // 转码后的bin文件地址
                  ],
                },
              ],
            },
          ],
          AutoTemplateParams: { DataContent: { isCanEdit: false } },
        }

        // 5. 创建场景
        const saveScene = await Create(params)

        if (saveScene.StatusCode === this.$store.state.rightStatusCode) {
          alertsuccess(this, this.$t('deviceMsg.configsuccess'))
          // 刷新列表以获取最新状态
          await this.getGalleryData()
        } else {
          // 创建失败，恢复状态
          alerterror(this, saveScene.StatusCode)
          this.updateItemStatus(item.SceneId, 3)
        }
      } catch (error) {
        // 发生异常时恢复状态
        if (item && item.SceneId) {
          this.updateItemStatus(item.SceneId, 3)
        }
      }
    },

    // 删除场景
    async handlerDelete() {
      // 1. 收集所有分类中选中的场景
      const selectScenes = []
      this.galleryData.forEach(category => {
        if (category.items) {
          category.items.forEach(item => {
            if (item.isChecked && item.SceneId) {
              selectScenes.push(item)
            }
          })
        }
      })

      // 2. 检查是否有选中项
      if (selectScenes.length === 0) {
        warning(this, this.$t('scene.selectScence'))
        return
      }

      try {
        // 3. 使用 Promise.all 并发删除
        await Promise.all(
          selectScenes.map(item => Delete({ sceneNo: item.SceneId }))
        )

        success(this, this.$t('notices.deleteSuccess'))
        this.isEdit = false
        
        // 4. 刷新列表
        await this.getGalleryData()
      } catch (error) {
        console.error('删除场景失败:', error)
      }
    },

    // 更新特定item的状态
    updateItemStatus(sceneId, newStatus) {
      if (!sceneId) return
      
      this.galleryData.forEach(category => {
        if (!category.items) return
        
        category.items.forEach(item => {
          if (item.SceneId === sceneId) {
            item.SceneStatus = newStatus
          }
        })
      })
    },
  },
}
</script>

<style scoped lang="scss">
$item-width: 140px; // 固定宽度
$item-height: 140px; // 固定高度
$item-gap: 12px; // 盒子之间的外边距
$bg-placeholder: #e0e0e0;
$title-color: #000000;

.gallery {
  padding: 20px;
  background-color: #fff;

  // 添加编辑栏样式
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    &-title {
      font-size: 18px;
      font-weight: 600;
      color: $title-color;
      margin: 0;
    }

    &-control {
      display: flex;
      gap: 10px;

      span {
        color: #3F9EFE;
        cursor: pointer;
        font-size: 14px;

        &.red {
          color: red;
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  // BFC 容器：确保 section 内部布局不影响外部
  &__section {
    display: flow-root;
    margin-bottom: 30px;
  }

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: $title-color;
    margin-bottom: 16px;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    // 抵消子项最外层的 margin
    margin-left: -$item-gap;
  }

  // 子项包装器：负责间距
  &__item-wrapper {
    padding: $item-gap;
    box-sizing: border-box;
  }
}
</style>
